import type {
  CardStub,
  DashboardSection,
} from '@/features/dashboard/api/schemas'

// Bristol hoists a dive's KPI cards into a row above its charts.
const KPI_DISPLAYS = new Set(['smartscalar', 'scalar'])

export const isKpi = (stub: CardStub) => KPI_DISPLAYS.has(stub.display)

/**
 * Finds the deep dive a card opens: the one the backend links it to, else the
 * first that features it. Indexes the sections once, for many lookups.
 */
export const deepDiveLookup = (sections: DashboardSection[]) => {
  const byId = new Map<string, DashboardSection>()
  const byCardId = new Map<number, DashboardSection>()
  for (const dive of sections) {
    if (dive.kind !== 'deep_dive') continue
    if (!byId.has(dive.id)) byId.set(dive.id, dive)
    for (const card of dive.cards) {
      if (!byCardId.has(card.cardId)) byCardId.set(card.cardId, dive)
    }
  }
  return (stub: CardStub): DashboardSection | undefined =>
    (stub.deepDiveId ? byId.get(stub.deepDiveId) : undefined) ??
    byCardId.get(stub.cardId)
}

export const deepDiveOf = (
  sections: DashboardSection[],
  stub: CardStub
): DashboardSection | undefined => deepDiveLookup(sections)(stub)
